const THUMBNAILS_POSITION = {
  ON_GALLERY: 'ON_GALLERY',
  OUTSIDE_GALLERY: 'OUTSIDE_GALLERY',
} as const;

export default THUMBNAILS_POSITION;
